import React, { FC, useState } from 'react';

import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

type TStyles = string | FlattenSimpleInterpolation;

import { FlattenSimpleInterpolation } from 'styled-components';

import * as ST from './styled';

interface IInfoBlockCustomStyles {
    wrapper?: TStyles,
    infoBlock?: TStyles,
    title?: TStyles,
    content?: TStyles,
}

interface IProps {
    children?: string | number | JSX.Element | JSX.Element[] | undefined,
    title?: string,
    header?: string,
    isCollapsable?: boolean,
    isCollapsedByDefault?: boolean,
    bottomContent?: string | number | JSX.Element | JSX.Element[],
    isRightSide?: boolean,
    customStyles?: IInfoBlockCustomStyles,
    onToggle?: () => void,
}

const InfoBlock: FC<IProps> = ({
    title,
    header,
    isCollapsable = false,
    isCollapsedByDefault = false,
    children,
    bottomContent,
    isRightSide,
    customStyles,
    onToggle,
}) => {
    const [toggled, setToggled] = useState(isCollapsedByDefault);

    const toggleBlock = () => {
        if (isCollapsable) {
            setToggled(!toggled);
            onToggle && onToggle();
        }
    };

    return (
        <ST.Wrapper isRightSide={isRightSide} styles={customStyles?.wrapper}>
            {header && <ST.Header data-test={'info-block-header'}>{header}</ST.Header>}
            <ST.BlockWrapper>
                <ST.InfoBlock toggled={toggled} hasTitle={!!title} styles={customStyles?.infoBlock}>
                    { title && <ST.TitleRow toggled={toggled} onClick={toggleBlock}>
                        <ST.Title data-test={'info-block-title'} styles={customStyles?.title}>{title}</ST.Title>
                        {isCollapsable &&
                            <ST.ButtonToggle
                                type={btnTypes.SECONDARY}
                                size={btnSizes.MIDDLE}
                                iconsSprite={'/static/images/full-buy/arrow_sprite.svg'}
                                symbolId={toggled ? 'down' : 'up'}
                                data-test={'info-block-collapse-btn'}
                            />
                        }
                    </ST.TitleRow>
                    }
                    <ST.Content toggled={toggled} styles={customStyles?.content}>
                        {children}
                    </ST.Content>
                    {bottomContent}
                </ST.InfoBlock>
            </ST.BlockWrapper>
        </ST.Wrapper>
    );
};

export default InfoBlock;
